export default __webpack_public_path__ + "static/media/bpbp94.b20e7fc7.png";